import axios from 'axios';
import api from './ApiAuthService';

export default class Event {
  static async getEvent(params: any) {
    try {
      let url = '/posts/events';

      // if (params) {
      //   url += '?';
      // }

      // if (params.page) {
        url += '?page=' + params.page;
      // }
  
      if (params.per_page) {
        url += '&per_page=' + params.per_page;
      }

      if (params.category) {
        url += '&category_id=' + params.category.value;
      }
  
      if (params.subCategory) {
        url += '&subcategory_id=' + params.subCategory.value;
      }
  
      if (params.search) {
        url += '&search=' + params.search;
      }
  
      if (params.country) {
        url += '&country=' + params.country.value;
      }
  
      if (params.state) {
        url += '&state=' + params.state.value;
      }
  
      if (params.city) {
        url += '&city=' + params.city.value;
      }

      if (url.charAt(url.length - 1) === '&' || url.charAt(url.length - 1) === '?') {
        url = url.slice(0, -1);
      }

      const response = await api.get(url);
      return response;

    } catch (error) {
      throw error;
    }
  }

  static async getEventFuture(params: any) {
    try {
      let url = '/posts/events/future';

      // if (params) {
      //   url += '?';
      // }

      // if (params.page) {
        url += '?page=' + params.page;
      // }
  
      if (params.per_page) {
        url += '&per_page=' + params.per_page;
      }

      if (params.category) {
        url += '&category_id=' + params.category.value;
      }
  
      if (params.subCategory) {
        url += '&subcategory_id=' + params.subCategory.value;
      }
  
      if (params.search) {
        url += '&search=' + params.search;
      }
  
      if (params.country) {
        url += '&country=' + params.country.value;
      }
  
      if (params.state) {
        url += '&state=' + params.state.value;
      }
  
      if (params.city) {
        url += '&city=' + params.city.value;
      }

      if (url.charAt(url.length - 1) === '&' || url.charAt(url.length - 1) === '?') {
        url = url.slice(0, -1);
      }

      const response = await api.get(url);
      return response;

    } catch (error) {
      throw error;
    }
  }

  static async getEventPast(params: any) {
    try {
      let url = '/posts/events/past';

      // if (params) {
      //   url += '?';
      // }

      // if (params.page) {
        url += '?page=' + params.page;
      // }
  
      if (params.per_page) {
        url += '&per_page=' + params.per_page;
      }

      if (params.category) {
        url += '&category_id=' + params.category.value;
      }
  
      if (params.subCategory) {
        url += '&subcategory_id=' + params.subCategory.value;
      }
  
      if (params.search) {
        url += '&search=' + params.search;
      }
  
      if (params.country) {
        url += '&country=' + params.country.value;
      }
  
      if (params.state) {
        url += '&state=' + params.state.value;
      }
  
      if (params.city) {
        url += '&city=' + params.city.value;
      }

      if (url.charAt(url.length - 1) === '&' || url.charAt(url.length - 1) === '?') {
        url = url.slice(0, -1);
      }

      const response = await api.get(url);
      return response;

    } catch (error) {
      throw error;
    }
  }

  static async getEventDetail(evento_id: number) {
    try {
      let url = '/posts/events/' + evento_id;
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async likeEvent(post_id: number) {
    try {
      let url = '/posts/' + post_id + '/like';
      const response = await api.post(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async post(dados: any) {
    try {
      const response = await api.post("/posts/events", dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async update(id: number, dados: any) {
    try {
      const response = await api.post(("/posts/events/" + id ), dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}